import React, { useState } from 'react';
import SendIcon from '@mui/icons-material/Send';

const CommentThread = ({ comments = [], onAdd, loading }) => {
  const [text, setText] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    await onAdd(text.trim());
    setText('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
    // Shift+Enter falls through naturally — textarea inserts a newline
  };

  return (
    <div className="flex flex-col gap-3">
      <h4 className="text-sm font-semibold text-gray-700">Comments</h4>

      {/* Comment list */}
      <div className="space-y-2 max-h-52 overflow-y-auto pr-1">
        {comments.length === 0 && (
          <p className="text-xs text-gray-400 italic">No comments yet.</p>
        )}
        {comments.map((c) => (
          <div key={c.id} className="flex gap-2">
            <div className="w-7 h-7 rounded-full bg-[#002169] flex items-center justify-center flex-shrink-0 text-white text-xs font-bold">
              {c.author_name ? c.author_name.charAt(0).toUpperCase() : '?'}
            </div>
            <div className="flex-1">
              <div className="flex items-baseline gap-2">
                <span className="text-xs font-semibold text-gray-800">{c.author_name || 'Staff'}</span>
                <span className="text-[10px] text-gray-400">
                  {new Date(c.created_at).toLocaleDateString('en-AU', { day:'numeric', month:'short', hour:'2-digit', minute:'2-digit' })}
                </span>
              </div>
              <p className="text-xs text-gray-700 mt-0.5 leading-relaxed whitespace-pre-wrap">{c.comment}</p>
            </div>
          </div>
        ))}
      </div>

      {/* New comment input */}
      <form onSubmit={handleSubmit} className="flex gap-2 mt-1 items-end">
        <textarea
          rows={2}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Add a comment…"
          disabled={loading}
          className="flex-1 text-sm border border-gray-200 rounded-lg px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-[#002169]/30 resize-none"
        />
        <button
          type="submit"
          disabled={!text.trim() || loading}
          className="flex items-center gap-1 px-3 py-1.5 bg-[#002169] text-white text-sm rounded-lg hover:bg-[#001550] disabled:opacity-40 transition"
        >
          <SendIcon style={{ fontSize: 14 }} />
        </button>
      </form>
    </div>
  );
};

export default CommentThread;
